<template>
  <div class="column">
    <div class="card">
      <div class="card-content">
        <div class="content">
          <b-field label="Category">
            <b-select placeholder="Select a category" expanded v-model="query.category">
              <option
                v-for="(category, index) in categories"
                :key="index"
                :value="category"
              >{{ category }}</option>
            </b-select>
          </b-field>
          <b-field label="Title">
            <b-input v-model="query.title"></b-input>
          </b-field>
          <b-field label="Description">
            <b-input v-model="query.description"></b-input>
          </b-field>
          <b-field label="Authentication">
            <div>
              <b-radio v-model="query.auth" native-value="null">No preference</b-radio>
              <b-radio v-model="query.auth" native-value="authKey">Key</b-radio>
              <b-radio v-model="query.auth" native-value="OAuth">OAuth</b-radio>
            </div>
          </b-field>
          <b-field label="HTTP/HTTPS">
            <b-switch v-model="query.https">HTTPS</b-switch>
          </b-field>
          <b-field label="CORS">
            <div>
              <b-radio v-model="query.cors" native-value="null">No preference</b-radio>
              <b-radio v-model="query.cors" native-value="yes">Yes</b-radio>
              <b-radio v-model="query.cors" native-value="no">No</b-radio>
            </div>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    query: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState([
      'categories',
    ]),
  },
};
</script>
